import { produce } from 'immer';
import { AnyAction } from 'redux';
import { FleetOperatingTimeActions } from './fleetOperatingTimeActions';
import { Optional } from 'lib/types/Optional';
import { FleetOperatingTime } from 'app/cross-cutting-concerns/communication/interfaces/am-api-graphql';
import { END_DATE, OperatingHoursChartUtils, START_DATE } from 'app/modules/cleaning/utils/OperatingHoursChartUtils';

export interface FleetOperatingTimeState {
  data: Optional<FleetOperatingTime>;
  isLoading: boolean;
  userHasInteracted: boolean;
  filters: {
    period: {
      startDate: string;
      endDate: string;
    };
  };
}

export const initialState: FleetOperatingTimeState = {
  data: null,
  isLoading: false,
  userHasInteracted: false,
  filters: {
    period: {
      startDate: OperatingHoursChartUtils.prepareStartDate(START_DATE).toISOString(),
      endDate: OperatingHoursChartUtils.prepareStartDate(END_DATE).toISOString(),
    },
  },
};

export const fleetOperatingTimeReducer = (state = initialState, action: AnyAction): FleetOperatingTimeState =>
  produce(state, draft => {
    switch (action.type) {
      case FleetOperatingTimeActions.GET_FLEET_OPERATING_TIME_REQUEST: {
        draft.isLoading = true;
        return draft;
      }

      case FleetOperatingTimeActions.GET_FLEET_OPERATING_TIME_SUCCESS: {
        const { fleetOperatingTime } = action.payload;
        draft.isLoading = false;
        draft.userHasInteracted = false;
        draft.data = fleetOperatingTime?.data ?? null;
        return draft;
      }

      case FleetOperatingTimeActions.GET_FLEET_OPERATING_TIME_ERROR: {
        draft.isLoading = false;
        draft.userHasInteracted = false;
        return draft;
      }

      case FleetOperatingTimeActions.RESET_STATE: {
        draft.isLoading = false;
        draft.userHasInteracted = false;
        return draft;
      }

      case FleetOperatingTimeActions.SET_PERIOD_FILTER: {
        const { period } = action.payload;

        draft.filters.period = period;
        draft.userHasInteracted = true;
        return draft;
      }

      default:
        return draft;
    }
  });
